import { z } from 'zod';
export const locationTypeEnum = z.enum([
    'building',
    'floor',
    'wing',
    'room',
    'area',
    'zone',
    'outdoor',
    'other',
]);
export const createLocationSchema = z.object({
    name: z.string().trim().min(1, 'Location name is required'),
    type: locationTypeEnum.default('area'),
    parent_id: z.string().uuid().optional(),
    description: z.string().optional(),
});
export const updateLocationSchema = z.object({
    name: z.string().trim().min(1).optional(),
    parent_id: z.string().uuid().nullable().optional(),
    description: z.string().optional(),
});
//# sourceMappingURL=location.schemas.js.map